import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import Stack from '@mui/material/Stack';
import dayjs from 'dayjs';
import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';
import FromAndToDatePicker from '../../../components/mui/FromAndToDatePicker';
import GlobalTable from '../../../components/CustomTableWithPagination/GlobalTable';
import { nonScheduleSessionVerificationTableHeader } from './utils/nonScheduleSessionVerificationTableHeader';
import GlobalDialog from '../../../components/mui/Dialogue/GlobalDialog';
import AttendanceDetails from './components/AttendanceDetailsVerification';

export default function NonScheduledSessionVerification() {
  // normal variable
  const dispatch = useDispatch();

  // Redux State-------------------------------------------------------------
  /*   const loading = useSelector((state) => state.crdMigration.coursePerfomanceAnalyticsTable.loading);
  const coursePerfomanceAnalyticsTable = useSelector((state) => state.crdMigration.coursePerfomanceAnalyticsTable.data);
  const meta = useSelector((state) => state.crdMigration.coursePerfomanceAnalyticsTable.meta); */
  //--------------------------------------------------------------------------

  // react state
  const [fromDate, setFromDate] = useState(dayjs().startOf('year').format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(dayjs().endOf('year').format('YYYY-MM-DD'));
  const [modalState, setModalState] = useState({
    actionKey: '',
    row: null,
  });

  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: 'asc' },
    frozenColumns: [],
    hiddenColumns: [],
  });

  //---------- DispatchParams ---------------------------------
  const dispatchParams = useMemo(
    () => ({
      page: tableState?.page,
      limit: tableState?.pageSize,
      fromDate,
      toDate,
      search: tableState?.search,
      sortBy: tableState?.sort?.field,
      sortOrder: tableState?.sort?.direction,
    }),
    [tableState?.page, tableState?.search, tableState?.sort, tableState?.pageSize, fromDate, toDate],
  );

  //---------* =-=-=-==-=--=-=-=-=- *---------------------------

  //-------------- Table Fetch ------------------------------
  useEffect(() => {
    // dispatch(getCoursePerfomanceAnalytics(dispatchParams));
  }, [dispatchParams, dispatch]);
  //-------------* Table Fetch *-----------------------------

  // table Head
  const tableHead = useMemo(() => nonScheduleSessionVerificationTableHeader({ setModalState }), []);

  // Global_Dialogue --------------------------------------------------------

  const handleButtonActionClick = useCallback((actionKey, row, actionType) => {
    if (!actionKey || !row) return;
    else {
      setModalState({
        actionKey,
        row,
      });
    }
  }, []);

  const modalConfigs = useMemo(
    () => [
      {
        actionKey: 'Attendance Details',
        title: 'Attendance Details',
        maxWidth: 'md',
        render: ({ row }) => <AttendanceDetails />,
      },
    ],
    [],
  );

  const activeConfig = useMemo(() => {
    if (!modalState.actionKey || !modalState.row) return null;
    return modalConfigs.find((c) => c?.actionKey === modalState.actionKey) || null;
  }, [modalConfigs, modalState.actionKey, modalState.row]);

  const rows = [
    {
      id: 1,
      slNo: 1,
      studentBatch: 'Arjun Nair / B-101',
      course: 'Foundation',
      subject: 'Mathematics',
      sessionDate: '05-02-2026',
      tutor: 'Rahul Menon',
      attendanceVerification: 'Verified',
    },
    {
      id: 2,
      slNo: 2,
      studentBatch: 'Meera Joseph / B-102',
      course: 'Little Genie',
      subject: 'English',
      sessionDate: '05-02-2026',
      tutor: 'Anjali Thomas',
      attendanceVerification: 'Pending',
    },
    {
      id: 3,
      slNo: 3,
      studentBatch: 'Vishnu Raj / B-103',
      course: 'Speak Pro',
      subject: 'Public Speaking',
      sessionDate: '06-02-2026',
      tutor: 'Kiran Kumar',
      attendanceVerification: 'Verified',
    },
    {
      id: 4,
      slNo: 4,
      studentBatch: 'Aisha Khan / B-104',
      course: 'Foundation',
      subject: 'Science',
      sessionDate: '06-02-2026',
      tutor: 'Rahul Menon',
      attendanceVerification: 'Rejected',
    },
    {
      id: 5,
      slNo: 5,
      studentBatch: 'Rohan Das / B-105',
      course: 'Little Genie',
      subject: 'Logical Reasoning',
      sessionDate: '07-02-2026',
      tutor: 'Anjali Thomas',
      attendanceVerification: 'Verified',
    },
  ];

  return (
    <GlobalWrapper title={'Non-Scheduled Sessions Verification'}>
      <Stack gap={2}>
        <Stack direction={{ xs: 'column', sm: 'row' }} gap={1}>
          <FromAndToDatePicker fromDate={fromDate} setFromDate={setFromDate} toDate={toDate} setToDate={setToDate} />
        </Stack>
        <GlobalTable
          rowUniqueId="sl_no"
          headers={tableHead}
          tableState={tableState}
          setTableState={setTableState}
          loading={false}
          rows={rows}
          meta={{}}
          onButtonActionClick={handleButtonActionClick}
        />

        <GlobalDialog
          title={activeConfig?.title}
          open={Boolean(modalState?.actionKey)}
          setOpen={(val) => {
            if (!val) setModalState({ actionKey: '', row: null });
          }}
          closeButton={true}
          content={activeConfig?.render ? activeConfig.render({ row: modalState.row }) : null}
          maxWidth={activeConfig?.maxWidth || 'md'}
          fullWidth={true}
        />
      </Stack>
    </GlobalWrapper>
  );
}
